// extracted by mini-css-extract-plugin
export default {"container":"HQBeta_container__ZTudS"};